import React, { Component } from 'react';

import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import moment from 'moment';

class RelatedFireStatRecord extends Component {

  //TODO: Duplicated with WFMI
  getDateString = (value) =>
  {
    return (value) ? moment(new Date(value)).format("MM/DD/YYYY h:mm A") : "";
  }

  getYesNo = (value) =>
  {
    return (value && (value === 1 || value === "1")) ? "Yes" : "No";
  }

  render()
  {
    return (
      <Paper elevation={3}>
      <Table size="small">
      <TableBody>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>FireStat ID:</TableCell>
        <TableCell>{this.props.record.FireStatID}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Discovery Calendar Year:</TableCell>
        <TableCell>{this.props.record.DiscoveryCalendarYear}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Fire ID:</TableCell>
        <TableCell>{this.props.record.FireID}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Fire Name:</TableCell>
        <TableCell>{this.props.record.FireName}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Local Fire Number:</TableCell>
        <TableCell>{this.props.record.LocalFireNumber}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Complex Name:</TableCell>
        <TableCell>{this.props.record.ComplexName}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Unique Fire ID:</TableCell>
        <TableCell>{this.props.record.UniqueFireID}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Location:</TableCell>
        <TableCell>{this.props.record.Location}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Region Forest:</TableCell>
        <TableCell>{this.props.record.RegionForest}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>District:</TableCell>
        <TableCell>{this.props.record.District}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Fire Number:</TableCell>
        <TableCell>{this.props.record.FireNumber}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Unit ID:</TableCell>
        <TableCell>{this.props.record.UnitID}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Protection Agency:</TableCell>
        <TableCell>{this.props.record.ProtectionAgency}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Ownership Origin:</TableCell>
        <TableCell>{this.props.record.OwnershipOrigin}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>State Abbreviation:</TableCell>
        <TableCell>{this.props.record.StateAbbreviation}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Fire Class Size:</TableCell>
        <TableCell>{this.props.record.FireClassSize}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Latitude Decimal Degrees:</TableCell>
        <TableCell>{this.props.record.LatitudeDecimalDegrees}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Longitude Decimal Degrees:</TableCell>
        <TableCell>{this.props.record.LongitudeDecimalDegrees}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Ignition Date:</TableCell>
        <TableCell>{this.props.record.IgnitionDate}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Discovery Date:</TableCell>
        <TableCell>{this.props.record.DiscoveryDate}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Detection Method:</TableCell>
        <TableCell>{this.props.record.DetectionMethod}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Discovered By:</TableCell>
        <TableCell>{this.props.record.DiscoveredBy}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Statistical Fire Cause Description:</TableCell>
        <TableCell>{this.props.record.StatisticalFireCauseDescription}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>General Fire Cause Description:</TableCell>
        <TableCell>{this.props.record.GeneralFireCauseDescription}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Specific Fire Cause Description:</TableCell>
        <TableCell>{this.props.record.SpecificFireCauseDescription}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Class People Cause Description:</TableCell>
        <TableCell>{this.props.record.ClassPeopleCauseDescription}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Incident Job Code:</TableCell>
        <TableCell>{this.props.record.IncidentJobCode}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Initial Strategy:</TableCell>
        <TableCell>{this.props.record.InitialStrategy}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>In Large Complex:</TableCell>
        <TableCell>{this.props.record.InLargeComplex}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Acres Burned in WUI:</TableCell>
        <TableCell>{this.props.record.AcresBurnedinWUI}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Escaped Fire:</TableCell>
        <TableCell>{this.props.record.EscapedFire}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Incident Job Code After Escape:</TableCell>
        <TableCell>{this.props.record.IncidentJobCodeAfterEscape}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Escape Date Time:</TableCell>
        <TableCell>{this.props.record.EscapeDateTime}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Initial Action Date:</TableCell>
        <TableCell>{this.props.record.InitialActionDate}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Suppression Strategy Attained Date:</TableCell>
        <TableCell>{this.props.record.SuppressionStrategyAttainedDate}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Fire Out Date:</TableCell>
        <TableCell>{this.props.record.FireOutDate}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>FS Acres:</TableCell>
        <TableCell>{this.props.record.FSAcresAutoTotal}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Non-FS Acres Protected by FS:</TableCell>
        <TableCell>{this.props.record.NonFSAcresProtectedbyFSAutoTotal}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Non-FS Acres Not Protected by FS:</TableCell>
        <TableCell>{this.props.record.NonFSAcresNotProtectedbyFSAutoTotal}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Total Acres Burned:</TableCell>
        <TableCell>{this.props.record.TotalAcresBurnedAutoTotal}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Acres Burned in WUI:</TableCell>
        <TableCell>{this.props.record.AcresBurnedinWUITotal}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Fire Intensity Level:</TableCell>
        <TableCell>{this.props.record.FireIntensityLevelDescription}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Report Weather Station:</TableCell>
        <TableCell>{this.props.record.ReportWeatherStation}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Cover Class:</TableCell>
        <TableCell>{this.props.record.CoverClassDescription}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Slope Percentage:</TableCell>
        <TableCell>{this.props.record.SlopePercentage}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Aspect:</TableCell>
        <TableCell>{this.props.record.Aspect}</TableCell>
      </TableRow>
      
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Ownership Unit:</TableCell>
        <TableCell>{this.props.record.OwnershipUnitID}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Protection Unit:</TableCell>
        <TableCell>{this.props.record.ProtectionUnitID}</TableCell>
      </TableRow>

      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Specific:</TableCell>
        <TableCell>{this.props.record.Specific}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Class:</TableCell>
        <TableCell>{this.props.record.Class}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Elevation Feet:</TableCell>
        <TableCell>{this.props.record.ElevationFeet}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Residences Destroyed:</TableCell>
        <TableCell>{this.props.record.ResidencesDestroyedAutoTotal}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Other Structures Destroyed:</TableCell>
        <TableCell>{this.props.record.OtherStructuresDestroyedAutoTotal}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Remarks:</TableCell>
        <TableCell>{this.props.record.Remarks}</TableCell>
      </TableRow>

      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Submitted By:</TableCell>
        <TableCell>{this.props.record.SubmittedBy}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Submitted Date:</TableCell>
        <TableCell>{this.props.record.SubmittedDate}</TableCell>
      </TableRow>

      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Approved By:</TableCell>
        <TableCell>{this.props.record.ApprovedBy}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Approved Date:</TableCell>
        <TableCell>{this.props.record.ApprovedDate}</TableCell>
      </TableRow>

      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Fuel Type:</TableCell>
        <TableCell>{this.props.record.FuelType}</TableCell>
        <TableCell style={{fontWeight:"bold"}}></TableCell>
        <TableCell></TableCell>
      </TableRow>

      </TableBody>
      </Table>
      </Paper>
  )
  }
}

export default RelatedFireStatRecord;
